const namespaced = true;

export const getters = {
  selectedOptions: state => {
    const selectedValues = state.value ? state.value.split(',') : [];

    return state.options.filter(option => selectedValues.includes(option.value));
  },
  humanReadableValue: (state, gttrs) => {
    return gttrs.selectedOptions.map(option => option.name).join(', ');
  },
};

export const mutations = {
  SET_VALUE(state, { value }) {
    state.value = value;
  },
};

const state = {
  key: 'status',
  name: 'Status',
  options: [
    {
      id: 1,
      name: 'Active',
      value: 'active',
    },
    {
      id: 2,
      name: 'Expired',
      value: 'expired',
    },
  ],
  value: 'active',
};

export default {
  namespaced,
  state,
  getters,
  mutations,
};
